import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Trash from 'react-feather/dist/icons/trash.js'
import Quill from '../../../../../components/Form/Field/Quill.jsx'
import CityTypeahead from '../../../../../components/Form/Field/CityTypeahead.jsx'
import DateForm from '../../../../../components/Form/Field/Date.jsx'
import api from '../../../../../../api'
import Aperture from 'react-feather/dist/icons/aperture.js'
import Tooltip from 'rc-tooltip'

const MissionsSection = ({
  isOpen,
  toggleSection,
  combinedMissions,
  openMissions,
  toggleMission,
  selectedMissions,
  handleSelectionChange,
  handleMissionInputChange,
  handleDelete,
  isRegistrationFlow,
  freelanceId,
}) => {
  const [beautifyingMissions, setBeautifyingMissions] = useState({})
  const [beautifiedMissions, setBeautifiedMissions] = useState({})
  const [selectedVersionMissions, setSelectedVersionMissions] = useState({})
  const [originalDescriptions, setOriginalDescriptions] = useState({})

  const handleBeautify = async (missionId, source, index, detail) => {
    const key = `${missionId}_${source}`
    setOriginalDescriptions(prev => ({ ...prev, [key]: detail }))
    setBeautifyingMissions(prev => ({ ...prev, [key]: true }))
    try {
      const response = await api.freelances.aiMissionDetailBeautification({ freelance: freelanceId, detail })
      setBeautifiedMissions(prev => ({ ...prev, [key]: response.data.beautified }))
      setSelectedVersionMissions(prev => ({ ...prev, [key]: 'beautified' }))
      handleMissionInputChange(index, source, 'description', response.data.beautified)
    } catch (e) {
      console.error(e)
    } finally {
      setBeautifyingMissions(prev => ({ ...prev, [key]: false }))
    }
  }

  const handleVersionSelect = (key, source, index, version, description) => {
    setSelectedVersionMissions(prev => ({ ...prev, [key]: version }))
    handleMissionInputChange(index, source, 'description', description)
  }

  return (
    <div className="mb-5">
      <div className="mb-3 d-flex align-items-center" onClick={() => toggleSection('missions')} style={{ cursor: 'pointer' }}>
        <span className="form-title-chip rounded-circle mr-2">3</span>

        <h4 className="mb-0">Vos missions</h4>

        <span className="ml-auto h3 text-secondary mb-0">{isOpen ? '-' : '+'}</span>
      </div>

      {isOpen && (
        <>
          {combinedMissions.length === 0 ? (
            <div className="callout callout-secondary text-center col-md-7 mx-auto">
              Aucune expérience à comparer.
            </div>
          ) : (
            combinedMissions.map((mission, index) => {
              const analyseKey = `${mission._id}_analyseData`
              const freelanceKey = `${mission._id}_freelanceData`
              const analyseVersion = selectedVersionMissions[analyseKey] || 'original'
              const freelanceVersion = selectedVersionMissions[freelanceKey] || 'original'

              return (
                <div key={mission._id} className="callout py-3">
                  <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                    <div className="d-flex align-items-start mr-4 flex-grow-1" onClick={() => toggleMission(mission._id)}>
                      <>
                        {mission.isIdentical && <span className="badge badge-success mt-1 mr-3">Identique</span>}
                        {mission.isDifferent && <span className="badge badge-info mt-1 mr-3">Différent</span>}
                        {mission.isNew && <span className="badge badge-primary text-white mt-1 mr-3">Nouveau</span>}
                        {mission.isCurrent && <span className="badge badge-secondary mt-1 mr-3">Twineeds</span>}
                      </>

                      <h5 className="mb-0">{mission.name}</h5>
                    </div>

                    <div className="ml-auto d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm btn-round mr-3"
                        onClick={(e) => {
                          e.stopPropagation()
                          handleDelete('missions', index)
                        }}
                      >
                        <Trash/>
                      </button>
                      <span className="h4 text-secondary mb-0" onClick={() => toggleMission(mission._id)}>{openMissions[mission._id] ? '-' : '+'}</span>
                    </div>
                  </div>

                  {openMissions[mission._id] && (
                    <div className="row mt-3">
                      {/* Analyse Data Column */}
                      {mission.analyseData && (
                        <div className={`col-md-${mission.isDifferent ? '6' : '12'}`}>
                          <div className={`p-3 mb-3 border rounded ${mission.isDifferent && selectedMissions[mission._id] !== 'analyseData' ? 'border-light' : ''}`}>
                            {mission.isDifferent && (
                              <div className="custom-control custom-switch mb-2">
                                <input className="custom-control-input" type="checkbox" id={`mission-${mission._id}-analyse`} checked={selectedMissions[mission._id] === 'analyseData'} onChange={() => handleSelectionChange('missions', mission._id, 'analyseData')} />
                                <label className="custom-control-label" htmlFor={`mission-${mission._id}-analyse`}>Nouvelle donnée du CV</label>
                              </div>
                            )}

                            {mission.analyseData && (
                              <div style={{ opacity: mission.isDifferent && selectedMissions[mission._id] !== 'analyseData' ? 0.5 : 1 }}>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group mb-2">
                                      <label>Fonction exercée</label>
                                      <input type="text" className="form-control" value={mission.analyseData.title} onChange={(e) => handleMissionInputChange(index, 'analyseData', 'title', e.target.value)} disabled={selectedMissions[mission._id] !== 'analyseData'} />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group mb-2">
                                      <label>Entreprise</label>
                                      <input type="text" className="form-control" value={mission.analyseData.company} onChange={(e) => handleMissionInputChange(index, 'analyseData', 'company', e.target.value)} disabled={selectedMissions[mission._id] !== 'analyseData'} />
                                    </div>
                                  </div>
                                </div>

                                <div className="form-check mb-2">
                                  <input
                                    id={`mission-${mission._id}-analyse-current`}
                                    type="checkbox"
                                    className="form-check-input mt-2"
                                    checked={mission.analyseData.current}
                                    onChange={(e) => handleMissionInputChange(index, 'analyseData', 'current', e.target.checked)}
                                    disabled={selectedMissions[mission._id] !== 'analyseData'}
                                  />

                                  <label className="form-check-label" htmlFor={`mission-${mission._id}-analyse-current`}>C'est ma mission actuelle</label>
                                </div>

                                <div className="row">
                                  <div className="col-md-6">
                                    <DateForm
                                      label="Date de début"
                                      dateFormat="MM/yyyy"
                                      placeholder="mm/aaaa"
                                      input={{
                                        name: `mission-analyse-start-${mission._id}`,
                                        value: mission.analyseData.start,
                                        onChange: (value) => handleMissionInputChange(index, 'analyseData', 'start', value),
                                        onFocus: () => {},
                                        onBlur: () => {},
                                      }}
                                      meta={{
                                        form: 'CvDataComparison',
                                        pristine: true,
                                        visited: false,
                                        submitFailed: false,
                                      }}
                                      disabled={selectedMissions[mission._id] !== 'analyseData'}
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <DateForm
                                      label="Date de fin"
                                      dateFormat="MM/yyyy"
                                      placeholder="mm/aaaa"
                                      input={{
                                        name: `mission-analyse-end-${mission._id}`,
                                        value: mission.analyseData.end,
                                        onChange: (value) => handleMissionInputChange(index, 'analyseData', 'end', value),
                                        onFocus: () => {},
                                        onBlur: () => {},
                                      }}
                                      meta={{
                                        form: 'CvDataComparison',
                                        pristine: true,
                                        visited: false,
                                        submitFailed: false,
                                      }}
                                      disabled={selectedMissions[mission._id] !== 'analyseData' || mission.analyseData.current}
                                    />
                                  </div>
                                </div>

                                <div className="form-group mb-2">
                                  <label>Ville</label>
                                  <CityTypeahead
                                    input={{
                                      name: `mission-analyse-locality-${mission._id}`,
                                      value: mission.analyseData.locality,
                                      onChange: (val) => {
                                        const value = (Array.isArray(val) && val.length > 0) ? (val[0].label || val[0]) : (val?.label || val || '')
                                        handleMissionInputChange(index, 'analyseData', 'locality', value)
                                      },
                                      onFocus: () => {},
                                      onBlur: () => {},
                                    }}
                                    meta={{
                                      form: 'CvDataComparison',
                                      pristine: true,
                                      visited: false,
                                      submitFailed: false,
                                    }}
                                    disabled={selectedMissions[mission._id] !== 'analyseData'}
                                    hasCountriesRestriction={false}
                                    placeholder="Paris..."
                                  />
                                </div>

                                <div className="form-group mb-2">
                                  <div className="d-flex align-items-center justify-content-between mb-1">
                                    <label className="mb-0">Missions réalisées</label>

                                    <Tooltip placement="left" overlay="Le texte a déjà été enrichi" trigger={beautifiedMissions[analyseKey] ? ['hover'] : []}>
                                      <span>
                                        <button type="button" className={`btn btn-secondary btn-sm ${beautifyingMissions[analyseKey] ? 'btn-loading' : ''}`} style={beautifyingMissions[analyseKey] ? { opacity: 0.7 } : undefined} disabled={!!beautifyingMissions[analyseKey] || !!beautifiedMissions[analyseKey] || (mission.isDifferent && selectedMissions[mission._id] !== 'analyseData')} onClick={() => handleBeautify(mission._id, 'analyseData', index, mission.analyseData.description)}>
                                          {beautifyingMissions[analyseKey]
                                            ? <svg style={{ width: 14, height: 14, animation: 'loader-rotate 1s linear infinite', marginRight: 6, marginBottom: 3, verticalAlign: 'middle', flexShrink: 0 }} viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="50 150" /></svg>
                                            : <Aperture size={14} style={{ marginRight: 6 }} />}
                                          Enrichir le contenu
                                        </button>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  <div className="row">
                                    <div className={beautifiedMissions[analyseKey] ? 'col-md-6' : 'col-12'}>
                                      {beautifiedMissions[analyseKey] && (
                                        <div className="custom-control custom-switch mb-1">
                                          <input className="custom-control-input" type="checkbox" id={`version-${analyseKey}-original`} checked={analyseVersion === 'original'} onChange={() => handleVersionSelect(analyseKey, 'analyseData', index, 'original', originalDescriptions[analyseKey])} />
                                          <label className="custom-control-label" htmlFor={`version-${analyseKey}-original`}>Actuel</label>
                                        </div>
                                      )}

                                      <div style={{ opacity: beautifiedMissions[analyseKey] && analyseVersion === 'beautified' ? 0.5 : 1 }}>
                                        <Quill
                                          input={{
                                            name: `mission-analyse-${mission._id}`,
                                            value: beautifiedMissions[analyseKey] ? (originalDescriptions[analyseKey] || mission.analyseData.description) : mission.analyseData.description,
                                            onChange: (value) => {
                                              handleMissionInputChange(index, 'analyseData', 'description', value)
                                              if (beautifiedMissions[analyseKey]) setOriginalDescriptions(prev => ({ ...prev, [analyseKey]: value }))
                                            },
                                            onFocus: () => {},
                                            onBlur: () => {},
                                          }}
                                          meta={{
                                            form: 'CvDataComparison',
                                            pristine: true,
                                            visited: false,
                                            submitFailed: false,
                                          }}
                                          readOnly={selectedMissions[mission._id] !== 'analyseData' || !!beautifyingMissions[analyseKey] || analyseVersion === 'beautified'}
                                        />
                                      </div>
                                    </div>

                                    {beautifiedMissions[analyseKey] && (
                                      <div className="col-md-6">
                                        <div className="custom-control custom-switch mb-1">
                                          <input className="custom-control-input" type="checkbox" id={`version-${analyseKey}-beautified`} checked={analyseVersion === 'beautified'} onChange={() => handleVersionSelect(analyseKey, 'analyseData', index, 'beautified', beautifiedMissions[analyseKey])} />
                                          <label className="custom-control-label" htmlFor={`version-${analyseKey}-beautified`}>Enrichi</label>
                                        </div>

                                        <div style={{ opacity: analyseVersion === 'original' ? 0.5 : 1 }}>
                                          <Quill
                                            input={{
                                              name: `mission-analyse-beautified-${mission._id}`,
                                              value: beautifiedMissions[analyseKey],
                                              onChange: () => {},
                                              onFocus: () => {},
                                              onBlur: () => {},
                                            }}
                                            meta={{
                                              form: 'CvDataComparison',
                                              pristine: true,
                                              visited: false,
                                              submitFailed: false,
                                            }}
                                            readOnly={analyseVersion !== 'beautified'}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Freelance Data Column */}
                      {!mission.isIdentical && (mission.freelanceData || mission.isDifferent) && (
                        <div className={`col-md-${mission.isDifferent ? '6' : '12'}`}>
                          <div className={`p-3 mb-3 border rounded ${mission.isDifferent && selectedMissions[mission._id] !== 'freelanceData' ? 'border-light' : ''}`}>
                            {mission.isDifferent && (
                              <div className="custom-control custom-switch mb-2">
                                <input className="custom-control-input" type="checkbox" id={`mission-${mission._id}-freelance`} checked={selectedMissions[mission._id] === 'freelanceData'} onChange={() => handleSelectionChange('missions', mission._id, 'freelanceData')} />
                                <label className="custom-control-label" htmlFor={`mission-${mission._id}-freelance`}>Donnée actuelle</label>
                              </div>
                            )}

                            {mission.freelanceData && (
                              <div style={{ opacity: mission.isDifferent && selectedMissions[mission._id] !== 'freelanceData' ? 0.5 : 1 }}>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group mb-2">
                                      <label>Fonction exercée</label>
                                      <input type="text" className="form-control" value={mission.freelanceData.title} onChange={(e) => handleMissionInputChange(index, 'freelanceData', 'title', e.target.value)} disabled={selectedMissions[mission._id] !== 'freelanceData'} />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group mb-2">
                                      <label>Entreprise</label>
                                      <input type="text" className="form-control" value={mission.freelanceData.company} onChange={(e) => handleMissionInputChange(index, 'freelanceData', 'company', e.target.value)} disabled={selectedMissions[mission._id] !== 'freelanceData'} />
                                    </div>
                                  </div>
                                </div>

                                <div className="form-check mb-2">
                                  <input id={`mission-${mission._id}-freelance-current`} type="checkbox" className="form-check-input mt-2" checked={mission.freelanceData.current} onChange={(e) => handleMissionInputChange(index, 'freelanceData', 'current', e.target.checked)} disabled={selectedMissions[mission._id] !== 'freelanceData'} />
                                  <label className="form-check-label" htmlFor={`mission-${mission._id}-freelance-current`}>C'est ma mission actuelle</label>
                                </div>

                                <div className="row">
                                  <div className="col-md-6">
                                    <DateForm
                                      label="Date de début"
                                      dateFormat="MM/yyyy"
                                      placeholder="mm/aaaa"
                                      input={{
                                        name: `mission-freelance-start-${mission._id}`,
                                        value: mission.freelanceData.start,
                                        onChange: (value) => handleMissionInputChange(index, 'freelanceData', 'start', value),
                                        onFocus: () => {},
                                        onBlur: () => {},
                                      }}
                                      meta={{
                                        form: 'CvDataComparison',
                                        pristine: true,
                                        visited: false,
                                        submitFailed: false,
                                      }}
                                      disabled={selectedMissions[mission._id] !== 'freelanceData'}
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <DateForm
                                      label="Date de fin"
                                      dateFormat="MM/yyyy"
                                      placeholder="mm/aaaa"
                                      input={{
                                        name: `mission-freelance-end-${mission._id}`,
                                        value: mission.freelanceData.end,
                                        onChange: (value) => handleMissionInputChange(index, 'freelanceData', 'end', value),
                                        onFocus: () => {},
                                        onBlur: () => {},
                                      }}
                                      meta={{
                                        form: 'CvDataComparison',
                                        pristine: true,
                                        visited: false,
                                        submitFailed: false,
                                      }}
                                      disabled={selectedMissions[mission._id] !== 'freelanceData' || mission.freelanceData.current}
                                    />
                                  </div>
                                </div>

                                <div className="form-group mb-2">
                                  <label>Ville</label>
                                  <CityTypeahead
                                    input={{
                                      name: `mission-freelance-locality-${mission._id}`,
                                      value: mission.freelanceData.locality,
                                      onChange: (val) => {
                                        const value = (Array.isArray(val) && val.length > 0) ? (val[0].label || val[0]) : (val?.label || val || '')
                                        handleMissionInputChange(index, 'freelanceData', 'locality', value)
                                      },
                                      onFocus: () => {},
                                      onBlur: () => {},
                                    }}
                                    meta={{
                                      form: 'CvDataComparison',
                                      pristine: true,
                                      visited: false,
                                      submitFailed: false,
                                    }}
                                    disabled={selectedMissions[mission._id] !== 'freelanceData'}
                                    hasCountriesRestriction={false}
                                    placeholder="Paris..."
                                  />
                                </div>

                                <div className="form-group mb-2">
                                  <div className="d-flex align-items-center justify-content-between mb-1">
                                    <label className="mb-0">Missions réalisées</label>

                                    <Tooltip placement="left" overlay="Le texte a déjà été enrichi" trigger={beautifiedMissions[freelanceKey] ? ['hover'] : []}>
                                      <span>
                                        <button type="button" className={`btn btn-secondary btn-sm ${beautifyingMissions[freelanceKey] ? 'btn-loading' : ''}`} style={beautifyingMissions[freelanceKey] ? { opacity: 0.7 } : undefined} disabled={!!beautifyingMissions[freelanceKey] || !!beautifiedMissions[freelanceKey] || (mission.isDifferent && selectedMissions[mission._id] !== 'freelanceData')} onClick={() => handleBeautify(mission._id, 'freelanceData', index, mission.freelanceData.description)}>
                                          {beautifyingMissions[freelanceKey]
                                            ? <svg style={{ width: 14, height: 14, animation: 'loader-rotate 1s linear infinite', marginRight: 6, marginBottom: 3, verticalAlign: 'middle', flexShrink: 0 }} viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="50 150" /></svg>
                                            : <Aperture size={14} style={{ marginRight: 6 }} />}
                                          Enrichir le contenu
                                        </button>
                                      </span>
                                    </Tooltip>
                                  </div>

                                  <div className="row">
                                    <div className={beautifiedMissions[freelanceKey] ? 'col-md-6' : 'col-12'}>
                                      {beautifiedMissions[freelanceKey] && (
                                        <div className="custom-control custom-switch mb-1">
                                          <input className="custom-control-input" type="checkbox" id={`version-${freelanceKey}-original`} checked={freelanceVersion === 'original'} onChange={() => handleVersionSelect(freelanceKey, 'freelanceData', index, 'original', originalDescriptions[freelanceKey])} />
                                          <label className="custom-control-label" htmlFor={`version-${freelanceKey}-original`}>Actuel</label>
                                        </div>
                                      )}

                                      <div style={{ opacity: beautifiedMissions[freelanceKey] && freelanceVersion === 'beautified' ? 0.5 : 1 }}>
                                        <Quill
                                          input={{
                                            name: `mission-freelance-${mission._id}`,
                                            value: beautifiedMissions[freelanceKey] ? (originalDescriptions[freelanceKey] || mission.freelanceData.description) : mission.freelanceData.description,
                                            onChange: (value) => {
                                              handleMissionInputChange(index, 'freelanceData', 'description', value)
                                              if (beautifiedMissions[freelanceKey]) setOriginalDescriptions(prev => ({ ...prev, [freelanceKey]: value }))
                                            },
                                            onFocus: () => {},
                                            onBlur: () => {},
                                          }}
                                          meta={{
                                            form: 'CvDataComparison',
                                            pristine: true,
                                            visited: false,
                                            submitFailed: false,
                                          }}
                                          readOnly={selectedMissions[mission._id] !== 'freelanceData' || !!beautifyingMissions[freelanceKey] || freelanceVersion === 'beautified'}
                                        />
                                      </div>
                                    </div>

                                    {beautifiedMissions[freelanceKey] && (
                                      <div className="col-md-6">
                                        <div className="custom-control custom-switch mb-1">
                                          <input className="custom-control-input" type="checkbox" id={`version-${freelanceKey}-beautified`} checked={freelanceVersion === 'beautified'} onChange={() => handleVersionSelect(freelanceKey, 'freelanceData', index, 'beautified', beautifiedMissions[freelanceKey])} />
                                          <label className="custom-control-label" htmlFor={`version-${freelanceKey}-beautified`}>Enrichi</label>
                                        </div>

                                        <div style={{ opacity: freelanceVersion === 'original' ? 0.5 : 1 }}>
                                          <Quill
                                            input={{
                                              name: `mission-freelance-beautified-${mission._id}`,
                                              value: beautifiedMissions[freelanceKey],
                                              onChange: () => {},
                                              onFocus: () => {},
                                              onBlur: () => {},
                                            }}
                                            meta={{
                                              form: 'CvDataComparison',
                                              pristine: true,
                                              visited: false,
                                              submitFailed: false,
                                            }}
                                            readOnly={freelanceVersion !== 'beautified'}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )
            })
          )}
        </>
      )}
    </div>
  )
}

MissionsSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSection: PropTypes.func.isRequired,
  combinedMissions: PropTypes.array.isRequired,
  openMissions: PropTypes.object.isRequired,
  toggleMission: PropTypes.func.isRequired,
  selectedMissions: PropTypes.object.isRequired,
  handleSelectionChange: PropTypes.func.isRequired,
  handleMissionInputChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isRegistrationFlow: PropTypes.bool.isRequired,
  freelanceId: PropTypes.number.isRequired,
}

MissionsSection.defaultProps = {
  isRegistrationFlow: false,
}

export default MissionsSection
